import { Variant } from '~/@types/product'

/**
 * Regex to match
 * - U+200B zero width space
 * - U+200C zero width non-joiner Unicode code point
 * - U+200D zero width joiner Unicode code point
 * - U+FEFF zero width no-break space Unicode code point
 *  */
const REGEX = /[\u200B-\u200D\uFEFF]/g

export function getEANSFromVariants(variants?: Variant[]) {
  return variants?.length > 0
    ? [...variants]
        ?.sort((a, b) => {
          // Get value from price amount accumulator
          const prevPrice = isNaN(parseInt(a?.priceAmount))
            ? -1
            : parseInt(a?.priceAmount)
          // Get value from price amount current variant
          const nextPrice = isNaN(parseInt(b?.priceAmount))
            ? -1
            : parseInt(b?.priceAmount)
          // Order by biggest price
          return nextPrice - prevPrice
        })
        ?.map((variant) => variant.barcode)
        ?.filter((item) => item !== null && item !== '')
        ?.map((item) => item?.replace(REGEX, '')) ?? []
    : []
}
